import { GPU } from './gpuData';

export interface GameBenchmark {
  gpuId: string;
  fps1080p: number;
  fps1440p: number;
  fps4k: number;
}

export interface Game {
  id: string;
  name: string;
  genre: string;
  releaseYear: number;
  icon: string;
  benchmarks: GameBenchmark[];
}

// Benchmark data - FPS values based on typical performance
export const gamesBenchmarks: Game[] = [
  {
    id: 'cyberpunk-2077',
    name: 'Cyberpunk 2077',
    genre: 'RPG',
    releaseYear: 2020,
    icon: '🌃',
    benchmarks: [
      { gpuId: 'rtx-5090', fps1080p: 220, fps1440p: 175, fps4k: 110 },
      { gpuId: 'rtx-4090', fps1080p: 185, fps1440p: 145, fps4k: 88 },
      { gpuId: 'rtx-5080', fps1080p: 175, fps1440p: 138, fps4k: 82 },
      { gpuId: 'rtx-4080-super', fps1080p: 165, fps1440p: 128, fps4k: 75 },
      { gpuId: 'rtx-5070-ti', fps1080p: 160, fps1440p: 125, fps4k: 72 },
      { gpuId: 'rtx-4080', fps1080p: 155, fps1440p: 120, fps4k: 70 },
      { gpuId: 'rtx-4070-ti-super', fps1080p: 140, fps1440p: 105, fps4k: 58 },
      { gpuId: 'rtx-5070', fps1080p: 130, fps1440p: 98, fps4k: 52 },
      { gpuId: 'rtx-4070-ti', fps1080p: 128, fps1440p: 95, fps4k: 50 },
      { gpuId: 'rtx-4070-super', fps1080p: 118, fps1440p: 85, fps4k: 45 },
      { gpuId: 'rtx-4070', fps1080p: 100, fps1440p: 72, fps4k: 38 },
      { gpuId: 'rtx-4060-ti', fps1080p: 82, fps1440p: 58, fps4k: 28 },
      { gpuId: 'rtx-4060', fps1080p: 65, fps1440p: 45, fps4k: 22 },
      { gpuId: 'rtx-3060', fps1080p: 55, fps1440p: 38, fps4k: 18 },
      { gpuId: 'rtx-3050', fps1080p: 38, fps1440p: 25, fps4k: 12 },
      { gpuId: 'rx-7900-xtx', fps1080p: 160, fps1440p: 125, fps4k: 72 },
      { gpuId: 'rx-9070-xt', fps1080p: 158, fps1440p: 122, fps4k: 70 },
      { gpuId: 'rx-7900-xt', fps1080p: 145, fps1440p: 110, fps4k: 62 },
      { gpuId: 'rx-9070', fps1080p: 135, fps1440p: 100, fps4k: 55 },
      { gpuId: 'rx-7900-gre', fps1080p: 125, fps1440p: 92, fps4k: 48 },
      { gpuId: 'rx-7800-xt', fps1080p: 108, fps1440p: 78, fps4k: 40 },
      { gpuId: 'rx-7700-xt', fps1080p: 92, fps1440p: 65, fps4k: 32 },
      { gpuId: 'rx-7600-xt', fps1080p: 72, fps1440p: 50, fps4k: 24 },
      { gpuId: 'rx-7600', fps1080p: 62, fps1440p: 42, fps4k: 20 },
      { gpuId: 'arc-b580', fps1080p: 70, fps1440p: 48, fps4k: 23 },
      { gpuId: 'arc-a770', fps1080p: 60, fps1440p: 42, fps4k: 20 },
      { gpuId: 'arc-a750', fps1080p: 52, fps1440p: 35, fps4k: 16 },
    ],
  },
  {
    id: 'fortnite',
    name: 'Fortnite',
    genre: 'Battle Royale',
    releaseYear: 2017,
    icon: '🎯',
    benchmarks: [
      { gpuId: 'rtx-5090', fps1080p: 450, fps1440p: 380, fps4k: 220 },
      { gpuId: 'rtx-4090', fps1080p: 400, fps1440p: 320, fps4k: 185 },
      { gpuId: 'rtx-5080', fps1080p: 380, fps1440p: 300, fps4k: 175 },
      { gpuId: 'rtx-4080-super', fps1080p: 360, fps1440p: 280, fps4k: 160 },
      { gpuId: 'rtx-5070-ti', fps1080p: 350, fps1440p: 270, fps4k: 155 },
      { gpuId: 'rtx-4080', fps1080p: 340, fps1440p: 260, fps4k: 150 },
      { gpuId: 'rtx-4070-ti-super', fps1080p: 310, fps1440p: 235, fps4k: 130 },
      { gpuId: 'rtx-5070', fps1080p: 290, fps1440p: 215, fps4k: 115 },
      { gpuId: 'rtx-4070-ti', fps1080p: 285, fps1440p: 210, fps4k: 112 },
      { gpuId: 'rtx-4070-super', fps1080p: 265, fps1440p: 195, fps4k: 100 },
      { gpuId: 'rtx-4070', fps1080p: 235, fps1440p: 170, fps4k: 85 },
      { gpuId: 'rtx-4060-ti', fps1080p: 195, fps1440p: 140, fps4k: 65 },
      { gpuId: 'rtx-4060', fps1080p: 165, fps1440p: 115, fps4k: 52 },
      { gpuId: 'rtx-3060', fps1080p: 145, fps1440p: 100, fps4k: 45 },
      { gpuId: 'rtx-3050', fps1080p: 105, fps1440p: 70, fps4k: 32 },
      { gpuId: 'rx-7900-xtx', fps1080p: 350, fps1440p: 270, fps4k: 155 },
      { gpuId: 'rx-9070-xt', fps1080p: 345, fps1440p: 265, fps4k: 152 },
      { gpuId: 'rx-7900-xt', fps1080p: 320, fps1440p: 245, fps4k: 138 },
      { gpuId: 'rx-9070', fps1080p: 295, fps1440p: 220, fps4k: 120 },
      { gpuId: 'rx-7900-gre', fps1080p: 275, fps1440p: 205, fps4k: 108 },
      { gpuId: 'rx-7800-xt', fps1080p: 245, fps1440p: 180, fps4k: 92 },
      { gpuId: 'rx-7700-xt', fps1080p: 210, fps1440p: 155, fps4k: 75 },
      { gpuId: 'rx-7600-xt', fps1080p: 175, fps1440p: 125, fps4k: 58 },
      { gpuId: 'rx-7600', fps1080p: 155, fps1440p: 108, fps4k: 48 },
      { gpuId: 'arc-b580', fps1080p: 170, fps1440p: 120, fps4k: 55 },
      { gpuId: 'arc-a770', fps1080p: 150, fps1440p: 105, fps4k: 48 },
      { gpuId: 'arc-a750', fps1080p: 130, fps1440p: 90, fps4k: 40 },
    ],
  },
  {
    id: 'valorant',
    name: 'Valorant',
    genre: 'Tactical Shooter',
    releaseYear: 2020,
    icon: '🔫',
    benchmarks: [
      { gpuId: 'rtx-5090', fps1080p: 800, fps1440p: 650, fps4k: 420 },
      { gpuId: 'rtx-4090', fps1080p: 750, fps1440p: 600, fps4k: 380 },
      { gpuId: 'rtx-5080', fps1080p: 720, fps1440p: 575, fps4k: 360 },
      { gpuId: 'rtx-4080-super', fps1080p: 680, fps1440p: 540, fps4k: 335 },
      { gpuId: 'rtx-5070-ti', fps1080p: 665, fps1440p: 525, fps4k: 325 },
      { gpuId: 'rtx-4080', fps1080p: 650, fps1440p: 510, fps4k: 315 },
      { gpuId: 'rtx-4070-ti-super', fps1080p: 600, fps1440p: 470, fps4k: 285 },
      { gpuId: 'rtx-5070', fps1080p: 560, fps1440p: 435, fps4k: 260 },
      { gpuId: 'rtx-4070-ti', fps1080p: 550, fps1440p: 425, fps4k: 255 },
      { gpuId: 'rtx-4070-super', fps1080p: 510, fps1440p: 395, fps4k: 235 },
      { gpuId: 'rtx-4070', fps1080p: 460, fps1440p: 355, fps4k: 205 },
      { gpuId: 'rtx-4060-ti', fps1080p: 395, fps1440p: 300, fps4k: 170 },
      { gpuId: 'rtx-4060', fps1080p: 340, fps1440p: 255, fps4k: 140 },
      { gpuId: 'rtx-3060', fps1080p: 300, fps1440p: 225, fps4k: 120 },
      { gpuId: 'rtx-3050', fps1080p: 230, fps1440p: 170, fps4k: 90 },
      { gpuId: 'rx-7900-xtx', fps1080p: 660, fps1440p: 520, fps4k: 320 },
      { gpuId: 'rx-9070-xt', fps1080p: 650, fps1440p: 510, fps4k: 315 },
      { gpuId: 'rx-7900-xt', fps1080p: 610, fps1440p: 475, fps4k: 290 },
      { gpuId: 'rx-9070', fps1080p: 565, fps1440p: 440, fps4k: 265 },
      { gpuId: 'rx-7900-gre', fps1080p: 530, fps1440p: 410, fps4k: 245 },
      { gpuId: 'rx-7800-xt', fps1080p: 475, fps1440p: 365, fps4k: 215 },
      { gpuId: 'rx-7700-xt', fps1080p: 420, fps1440p: 320, fps4k: 185 },
      { gpuId: 'rx-7600-xt', fps1080p: 355, fps1440p: 270, fps4k: 150 },
      { gpuId: 'rx-7600', fps1080p: 315, fps1440p: 235, fps4k: 130 },
      { gpuId: 'arc-b580', fps1080p: 345, fps1440p: 260, fps4k: 145 },
      { gpuId: 'arc-a770', fps1080p: 310, fps1440p: 230, fps4k: 125 },
      { gpuId: 'arc-a750', fps1080p: 270, fps1440p: 200, fps4k: 105 },
    ],
  },
  {
    id: 'hogwarts-legacy',
    name: 'Hogwarts Legacy',
    genre: 'Action RPG',
    releaseYear: 2023,
    icon: '🧙',
    benchmarks: [
      { gpuId: 'rtx-5090', fps1080p: 185, fps1440p: 145, fps4k: 92 },
      { gpuId: 'rtx-4090', fps1080p: 155, fps1440p: 120, fps4k: 75 },
      { gpuId: 'rtx-5080', fps1080p: 145, fps1440p: 112, fps4k: 68 },
      { gpuId: 'rtx-4080-super', fps1080p: 138, fps1440p: 105, fps4k: 62 },
      { gpuId: 'rtx-5070-ti', fps1080p: 132, fps1440p: 100, fps4k: 58 },
      { gpuId: 'rtx-4080', fps1080p: 128, fps1440p: 98, fps4k: 56 },
      { gpuId: 'rtx-4070-ti-super', fps1080p: 115, fps1440p: 85, fps4k: 48 },
      { gpuId: 'rtx-5070', fps1080p: 105, fps1440p: 78, fps4k: 42 },
      { gpuId: 'rtx-4070-ti', fps1080p: 102, fps1440p: 75, fps4k: 40 },
      { gpuId: 'rtx-4070-super', fps1080p: 95, fps1440p: 68, fps4k: 36 },
      { gpuId: 'rtx-4070', fps1080p: 82, fps1440p: 58, fps4k: 30 },
      { gpuId: 'rtx-4060-ti', fps1080p: 68, fps1440p: 48, fps4k: 24 },
      { gpuId: 'rtx-4060', fps1080p: 55, fps1440p: 38, fps4k: 18 },
      { gpuId: 'rtx-3060', fps1080p: 48, fps1440p: 32, fps4k: 15 },
      { gpuId: 'rtx-3050', fps1080p: 35, fps1440p: 22, fps4k: 10 },
      { gpuId: 'rx-7900-xtx', fps1080p: 132, fps1440p: 100, fps4k: 58 },
      { gpuId: 'rx-9070-xt', fps1080p: 128, fps1440p: 98, fps4k: 56 },
      { gpuId: 'rx-7900-xt', fps1080p: 118, fps1440p: 88, fps4k: 50 },
      { gpuId: 'rx-9070', fps1080p: 108, fps1440p: 80, fps4k: 44 },
      { gpuId: 'rx-7900-gre', fps1080p: 100, fps1440p: 72, fps4k: 38 },
      { gpuId: 'rx-7800-xt', fps1080p: 88, fps1440p: 62, fps4k: 32 },
      { gpuId: 'rx-7700-xt', fps1080p: 75, fps1440p: 52, fps4k: 26 },
      { gpuId: 'rx-7600-xt', fps1080p: 60, fps1440p: 42, fps4k: 20 },
      { gpuId: 'rx-7600', fps1080p: 52, fps1440p: 35, fps4k: 16 },
      { gpuId: 'arc-b580', fps1080p: 58, fps1440p: 40, fps4k: 19 },
      { gpuId: 'arc-a770', fps1080p: 50, fps1440p: 35, fps4k: 16 },
      { gpuId: 'arc-a750', fps1080p: 42, fps1440p: 28, fps4k: 13 },
    ],
  },
  {
    id: 'call-of-duty-mw3',
    name: 'Call of Duty: MW3',
    genre: 'FPS',
    releaseYear: 2023,
    icon: '💥',
    benchmarks: [
      { gpuId: 'rtx-5090', fps1080p: 320, fps1440p: 265, fps4k: 165 },
      { gpuId: 'rtx-4090', fps1080p: 280, fps1440p: 225, fps4k: 140 },
      { gpuId: 'rtx-5080', fps1080p: 265, fps1440p: 212, fps4k: 130 },
      { gpuId: 'rtx-4080-super', fps1080p: 250, fps1440p: 200, fps4k: 122 },
      { gpuId: 'rtx-5070-ti', fps1080p: 242, fps1440p: 195, fps4k: 118 },
      { gpuId: 'rtx-4080', fps1080p: 238, fps1440p: 190, fps4k: 115 },
      { gpuId: 'rtx-4070-ti-super', fps1080p: 215, fps1440p: 170, fps4k: 100 },
      { gpuId: 'rtx-5070', fps1080p: 198, fps1440p: 158, fps4k: 90 },
      { gpuId: 'rtx-4070-ti', fps1080p: 195, fps1440p: 155, fps4k: 88 },
      { gpuId: 'rtx-4070-super', fps1080p: 182, fps1440p: 142, fps4k: 80 },
      { gpuId: 'rtx-4070', fps1080p: 160, fps1440p: 125, fps4k: 68 },
      { gpuId: 'rtx-4060-ti', fps1080p: 135, fps1440p: 102, fps4k: 52 },
      { gpuId: 'rtx-4060', fps1080p: 112, fps1440p: 82, fps4k: 42 },
      { gpuId: 'rtx-3060', fps1080p: 98, fps1440p: 72, fps4k: 35 },
      { gpuId: 'rtx-3050', fps1080p: 72, fps1440p: 50, fps4k: 25 },
      { gpuId: 'rx-7900-xtx', fps1080p: 245, fps1440p: 195, fps4k: 118 },
      { gpuId: 'rx-9070-xt', fps1080p: 240, fps1440p: 190, fps4k: 115 },
      { gpuId: 'rx-7900-xt', fps1080p: 222, fps1440p: 175, fps4k: 105 },
      { gpuId: 'rx-9070', fps1080p: 205, fps1440p: 162, fps4k: 95 },
      { gpuId: 'rx-7900-gre', fps1080p: 190, fps1440p: 150, fps4k: 85 },
      { gpuId: 'rx-7800-xt', fps1080p: 168, fps1440p: 132, fps4k: 72 },
      { gpuId: 'rx-7700-xt', fps1080p: 145, fps1440p: 112, fps4k: 60 },
      { gpuId: 'rx-7600-xt', fps1080p: 118, fps1440p: 90, fps4k: 46 },
      { gpuId: 'rx-7600', fps1080p: 102, fps1440p: 78, fps4k: 38 },
      { gpuId: 'arc-b580', fps1080p: 115, fps1440p: 88, fps4k: 45 },
      { gpuId: 'arc-a770', fps1080p: 100, fps1440p: 75, fps4k: 38 },
      { gpuId: 'arc-a750', fps1080p: 85, fps1440p: 62, fps4k: 32 },
    ],
  },
  {
    id: 'red-dead-redemption-2',
    name: 'Red Dead Redemption 2',
    genre: 'Action Adventure',
    releaseYear: 2019,
    icon: '🤠',
    benchmarks: [
      { gpuId: 'rtx-5090', fps1080p: 195, fps1440p: 155, fps4k: 98 },
      { gpuId: 'rtx-4090', fps1080p: 165, fps1440p: 128, fps4k: 78 },
      { gpuId: 'rtx-5080', fps1080p: 155, fps1440p: 120, fps4k: 72 },
      { gpuId: 'rtx-4080-super', fps1080p: 145, fps1440p: 112, fps4k: 66 },
      { gpuId: 'rtx-5070-ti', fps1080p: 140, fps1440p: 108, fps4k: 62 },
      { gpuId: 'rtx-4080', fps1080p: 138, fps1440p: 105, fps4k: 60 },
      { gpuId: 'rtx-4070-ti-super', fps1080p: 122, fps1440p: 92, fps4k: 52 },
      { gpuId: 'rtx-5070', fps1080p: 112, fps1440p: 85, fps4k: 46 },
      { gpuId: 'rtx-4070-ti', fps1080p: 110, fps1440p: 82, fps4k: 44 },
      { gpuId: 'rtx-4070-super', fps1080p: 102, fps1440p: 75, fps4k: 40 },
      { gpuId: 'rtx-4070', fps1080p: 88, fps1440p: 65, fps4k: 34 },
      { gpuId: 'rtx-4060-ti', fps1080p: 72, fps1440p: 52, fps4k: 26 },
      { gpuId: 'rtx-4060', fps1080p: 60, fps1440p: 42, fps4k: 20 },
      { gpuId: 'rtx-3060', fps1080p: 52, fps1440p: 36, fps4k: 17 },
      { gpuId: 'rtx-3050', fps1080p: 38, fps1440p: 25, fps4k: 12 },
      { gpuId: 'rx-7900-xtx', fps1080p: 140, fps1440p: 108, fps4k: 62 },
      { gpuId: 'rx-9070-xt', fps1080p: 138, fps1440p: 105, fps4k: 60 },
      { gpuId: 'rx-7900-xt', fps1080p: 125, fps1440p: 95, fps4k: 54 },
      { gpuId: 'rx-9070', fps1080p: 115, fps1440p: 88, fps4k: 48 },
      { gpuId: 'rx-7900-gre', fps1080p: 108, fps1440p: 80, fps4k: 42 },
      { gpuId: 'rx-7800-xt', fps1080p: 95, fps1440p: 68, fps4k: 36 },
      { gpuId: 'rx-7700-xt', fps1080p: 80, fps1440p: 58, fps4k: 30 },
      { gpuId: 'rx-7600-xt', fps1080p: 65, fps1440p: 46, fps4k: 22 },
      { gpuId: 'rx-7600', fps1080p: 55, fps1440p: 38, fps4k: 18 },
      { gpuId: 'arc-b580', fps1080p: 62, fps1440p: 44, fps4k: 21 },
      { gpuId: 'arc-a770', fps1080p: 54, fps1440p: 38, fps4k: 18 },
      { gpuId: 'arc-a750', fps1080p: 46, fps1440p: 32, fps4k: 15 },
    ],
  },
];

export type Resolution = '1080p' | '1440p' | '4k';

export const resolutionLabels: Record<Resolution, string> = {
  '1080p': '1080p (Full HD)',
  '1440p': '1440p (QHD)',
  '4k': '4K (Ultra HD)',
};

export function getBenchmarkForGPU(gpuId: string, gameId: string): GameBenchmark | undefined {
  const game = gamesBenchmarks.find(g => g.id === gameId);
  return game?.benchmarks.find(b => b.gpuId === gpuId);
}

export function getFPSForResolution(benchmark: GameBenchmark, resolution: Resolution): number {
  switch (resolution) {
    case '1080p': return benchmark.fps1080p;
    case '1440p': return benchmark.fps1440p;
    case '4k': return benchmark.fps4k;
  }
}
